import CLIENT, {DEFAULT_LANGUAGE_STRINGS as _defaultLanguageStrings} from '../utils/languageClient';
import {vsprintf} from 'sprintf-js';
import Logger, {LOG_LEVELS} from '../utils/logger';
import format from "format-util";

export const MODULE_NAME = 'LANGUAGES_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
}

const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');

export const ACTION_TYPES = {
  LOAD,
  LOAD_OK,
  LOAD_FAIL
};

export const DEFAULT_LANGUAGE_STRINGS = _defaultLanguageStrings;

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: DEFAULT_LANGUAGE_STRINGS, loading: false, error: null}, action) => {
  log.debug('updateSubStateFromAction: ', action, state );
  const getNewState = (action, state) => {
    switch (action.type) {
      case LOAD:
        return  Object.assign({}, state, {loading: true, error: null});
      case LOAD_OK:
        return Object.assign({}, state, {data: action.languageStrings, loading: false, error: null});
      case LOAD_FAIL:
        return Object.assign({}, state, {data: DEFAULT_LANGUAGE_STRINGS, loading: false, error: action.error});
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction:  newState', newState );
  return newState;
};

function vsprintfFormatter(languageStrings, languageStringKey, params)  {
  const string = languageStrings[languageStringKey] || 'MISSING LANGUAGE STRING: '+languageStringKey;
  return vsprintf(string, params);
}

function formatUtilFormatter(languageStrings, languageStringKey, params)  {
  params = params || [];
  const string = languageStrings[languageStringKey] || 'MISSING LANGUAGE STRING: '+languageStringKey;
  const args = [string].concat(params);
  return format.apply(this, args);
}

export const API = {
  doLoad: (language) => {
    log.debug('doLoad: ',);
    return (dispatch, getState) => {
      dispatch({type: LOAD});
      CLIENT.getLanguageStrings(language)
        .then((languageStrings) => {
          log.debug('doLoad: success: ', languageStrings );
          dispatch({type: LOAD_OK, languageStrings: languageStrings});
        })
        .catch((error) => {
          log.debug('doLoad: failure: ', error );
          dispatch({type: LOAD_FAIL, error});
        });
    }
  },
  format: (loadedLanguages, field, args) => {
    const languageStrings = (loadedLanguages && loadedLanguages.data) || DEFAULT_LANGUAGE_STRINGS;
    return formatUtilFormatter(languageStrings, field, args);
  },
  formatUtilFormatter,
  vsprintfFormatter
};

export default API;

